import { TextField } from "@mui/material";
import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";
import { TextL, TextM, TextRS } from "../../common/text";

export const ContentContainer = styled(ContentContainerBase)`
  align-items: center;
`;

export const RegisterHeader = styled.div`
  width: 80%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 30px;
  @media ${({ theme }) => theme.device.tablet} {
    margin-bottom: 50px;
  }
`;

export const RegisterWrapper = styled.div`
  width: 80%;
  height: 25%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 10px;

  gap: 30px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 50px;
  }
`;

export const RegisterPhoneInput = styled(TextField)`
  width: 80%;
  height: 25px;
  .MuiInputBase-input {
    font-size: 16px;
    font-family: "Bold";
    text-align: center;
  }
  label.Mui-focused {
    color: #f44b59;
  }
  .MuiInput-underline:after {
    border-bottom-color: #f44b59;
  }
  .MuiFormHelperText-root {
    color: #f44b59;
    text-align: center;
  }
  @media ${({ theme }) => theme.device.tablet} {
    width: 60%;
    height: 45px;
    .MuiInputBase-input {
      font-size: 23px;
      font-family: "Bold";
      text-align: center;
    }
    .MuiFormHelperText-root {
      font-size: 16px;
    }
  }
`;

export const PhoneButton = styled.div`
  width: 70%;
  height: 50px;
  border-radius: 5px;
  background-color: ${({ isValidPhoneNum }) => (isValidPhoneNum ? "#f44b59" : "#eaeaea")};
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${({ theme }) => theme.device.tablet} {
    width: 50%;
    height: 60px;
  }
`;

export const PhoneButtonText = styled(TextM)`
  color: ${({ isValidPhoneNum }) => (isValidPhoneNum ? "#FFF" : "#9F9F9F")};
`;
